import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { Typography, Tooltip } from '@material-ui/core';
import { ToPercentageString } from 'services/formatService';
import bungaloIcon from 'assets/underwriteIcons/bungaloIcon.svg';
import msrIcon from 'assets/underwriteIcons/MSRIcon.svg';

const PropertyUWProformaStrategy = ({ classes, proformaValuation, shouldCalculateProforma }) => {

    const valuationOutput = proformaValuation.valuationOutput;
    const fontColor = (proformaValuation.isCompleted && proformaValuation.isLatest === false) ? '#F50057' : null
    const opacity = shouldCalculateProforma ? 0.4 : 1;

    let strategyNameContent;
    if (!valuationOutput.proformaStrategy) {
        strategyNameContent = null;
    }
    else if (valuationOutput.proformaStrategy === 'Rent') {
        strategyNameContent =
        (
            valuationOutput?.repairScope ?
            <Tooltip title={`Repair Scope: ${valuationOutput.repairScope}`}>
                <Typography variant='body2' className={classes.stragetyName} noWrap>
                    <span>{valuationOutput.rentAssumptionBestFitIcbmOrder?.strategyName}</span>
                </Typography>
            </Tooltip> :
            <Typography variant='body2' className={classes.stragetyName} noWrap>
                <span>{valuationOutput.rentAssumptionBestFitIcbmOrder?.strategyName}</span>
            </Typography>
        );
    }
    else if (valuationOutput.proformaStrategy === 'Retail') {
        strategyNameContent =
        (
            valuationOutput?.repairScope ?
            <Tooltip title={valuationOutput?.repairScope ? `Repair Scope: ${valuationOutput.repairScope}` : null}>
                <Typography variant='body2' className={classes.stragetyName} noWrap>
                    <span>{valuationOutput.sellAssumptionBestFitIcbmOrder?.strategyName}</span>
                </Typography>
            </Tooltip> :
            <Typography variant='body2' className={classes.stragetyName} noWrap>
                <span>{valuationOutput.sellAssumptionBestFitIcbmOrder?.strategyName}</span>
            </Typography>
        );
    }

    let capRateContent;
    if (valuationOutput.proformaStrategy === 'Rent') {
        capRateContent =
            (<Tooltip title={`Pro forma Strategy: ${valuationOutput.proformaStrategy}`}>
                <Typography variant='body2' className={classNames(classes.headers, classes.stragetyMaxBid)} noWrap>
                    Cap Rate: <span>{ToPercentageString(valuationOutput.capRate)}</span>
                </Typography>
            </Tooltip>);
    }
    else if (valuationOutput.proformaStrategy === 'Retail') {
        capRateContent =
            (<Tooltip title={`Pro forma Strategy: ${valuationOutput.proformaStrategy}`}>
                <Typography variant='body2' className={classNames(classes.headers, classes.stragetyMaxBid)} noWrap>
                    Net Margin: <span>{ToPercentageString(valuationOutput.netMargin)}</span>
                </Typography>
            </Tooltip>);
    }

    const icon = React.useMemo(() => {
      switch (valuationOutput.proformaStrategy) {
        case 'Retail':
          return (<img
            src={bungaloIcon}
            className={classes.visualIndicator}
            alt="Icon"
          />);
        case 'Rent':
          return (<img
            src={msrIcon}
            className={classes.visualIndicator}
            alt="Icon"
          />);
        default: return null;
      }
    }, [valuationOutput.proformaStrategy]);

    return (
        <div className={classes.strategySection} style={{ backgroundColor: '#fff', opacity: opacity, color: fontColor }}>
          {capRateContent}
          {/* {strategyNameContent} */}
          {icon}
        </div>
    )
}

const styles = theme => ({
    headers: {
        fontWeight: 'bold',
        fontSize: '14px',
        alignSelf: 'center'
    },
    strategySection: {
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        paddingTop: '5px',
        paddingLeft: '10px'
    },
    stragetyMaxBid: {
        flexGrow: 0,
        flexShrink: 0
    },
    stragetyName: {
        flexGrow: 0,
        flexShrink: 1,
        paddingLeft: '10px'
    },
    visualIndicator: {
      width: 14,
      height: 14,
      marginLeft: 20,
      marginBottom: 2
    }
});

export default withStyles(styles)(PropertyUWProformaStrategy);
